import React from 'react';
import { Box, Button, SxProps } from '@mui/material';

const boxProps: SxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '600px',
  minWidth: { xs: '350px', sm: '400px', md: '600px', lg: '600px' },
  color: 'white',
  flexDirection: { xs: 'column', sm: 'row' },
  backgroundColor: '#1E293B',
  padding: '15px 30px',
  zIndex: 1000,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '20px',
  overflow: 'hidden',
  backgroundImage: `url(${process.env.PUBLIC_URL}/images/backgrounds/graphic.png)`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 'inherit',
    padding: '3px',
    background: 'linear-gradient(90deg, #DB86F8 0%, #006FD6 100%)',
    WebkitMask:
      'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    maskComposite: 'exclude',
    zIndex: -1,
  },
};

interface ISubmissionPopupProps {
  open: boolean;
  onClose: () => void;
}

const SubmissionPopup: React.FC<ISubmissionPopupProps> = ({
  open,
  onClose,
}) => {
  return (
    <Box sx={boxProps}>
      <Box sx={{ display: 'flex', flexDirection: 'column', p: '15px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 2, sm: 2 },
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/backgrounds/chat-bot.png`}
            alt="chat-bot"
            style={{ width: '57px', height: '57px', marginRight: '10px' }}
          />
          <Box sx={{ flexGrow: 1 }}>
            <span style={{ fontSize: '16px', fontWeight: 600 }}>
              Upon submission, you&apos;ll receive a detailed analysis of your
              answer and personalized feedback to help you improve! 🚀
            </span>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: {
              xs: 'center',
              sm: 'center',
              md: 'flex-end',
              lg: 'flex-end',
            },
            mt: '5px',
          }}
        >
          <Button
            variant="contained"
            sx={{
              backgroundColor: '#E2E8F0',
              color: '#1E293B',
              fontSize: '14px',
              fontWeight: 600,
              pl: 2,
              pr: 2,
              mt: { xs: '15px', sm: '15px', md: '0px', lg: '0px' },
              borderRadius: '10px',
              '&:hover': {
                backgroundColor: '#d9d9d9',
              },
            }}
            onClick={onClose}
          >
            Dismiss
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SubmissionPopup;
